<template>
  <div class="container mb-5" id="app">
    <the-header />
    <main>
      <transition name="view" mode="out-in" appear>
        <router-view />
      </transition>
    </main>
  </div>
</template>

<script>
import TheHeader from '@/components/TheHeader/TheHeader'

export default {
  components: {
    TheHeader,
  },
}
</script>
